<template>
    <div class="field-container-2">
        <div class="regular-type-header">
            {{header}}
        </div>
        <template v-if="storeReferenceContent">
            <div>
                <template v-if="field.allowsMultiple">
                    <div v-for="(each, index) in value.map(valueToReferenceObj)">
                        <div class="linked-entry-container">
                            <div v-if="isMedia">
                                <div>
                                    <img v-if="getMediaTypeOfEntry(each).category === 'Image'"
                                         :src="getUrlField(each.fields).value" alt=""
                                         class="data-table-thumbnail">
                                    <font-awesome-icon
                                            v-else-if="getMediaTypeOfEntry(each).category === 'Audio'"
                                            :icon="['fal', 'file-audio']" size="2x" class="category-icon"/>
                                    <font-awesome-icon
                                            v-else-if="getMediaTypeOfEntry(each).category === 'PDF'"
                                            :icon="['fal', 'file-pdf']" size="2x" class="category-icon"/>
                                    <font-awesome-icon
                                            v-else-if="getMediaTypeOfEntry(each).category === 'Video'"
                                            :icon="['fal', 'file-video']" size="2x" class="category-icon"/>
                                </div>
                            </div>
                            <div>
                                <sfr-entry-tooltip :entry="each">
                                    <div class="linked-entry" slot="activator">
                                        <span>{{displayReferenceEntry(each)}}</span>
                                    </div>
                                </sfr-entry-tooltip>
                            </div>
                            <div v-if="value.length > 1 || !isRequired" class="delete-entry"
                                 v-on:click="unsetReference(index)">
                                <font-awesome-icon :icon="['fal', 'minus-circle']"/>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div>
                        <template v-if="value">
                            <div class="linked-entry-container">
                                <div v-if="isMedia">
                                    <div>
                                        <img v-if="getMediaTypeOfEntry(valueToReferenceObj(value)).category === 'Image'"
                                             :src="getUrlField(valueToReferenceObj(value).fields).value" alt="hello"
                                             class="data-table-thumbnail">
                                        <font-awesome-icon
                                                v-else-if="getMediaTypeOfEntry(valueToReferenceObj(value)).category === 'Audio'"
                                                :icon="['fal', 'file-audio']" size="2x" class="category-icon"/>
                                        <font-awesome-icon
                                                v-else-if="getMediaTypeOfEntry(valueToReferenceObj(value)).category === 'PDF'"
                                                :icon="['fal', 'file-pdf']" size="2x" class="category-icon"/>
                                        <font-awesome-icon
                                                v-else-if="getMediaTypeOfEntry(valueToReferenceObj(value)).category === 'Video'"
                                                :icon="['fal', 'file-video']" size="2x" class="category-icon"/>
                                    </div>
                                </div>
                                <div>
                                    <sfr-entry-tooltip :entry="valueToReferenceObj(value)">
                                        <div class="linked-entry" slot="activator">
                                            <span>{{displayReferenceEntry(valueToReferenceObj(value))}}</span>
                                        </div>
                                    </sfr-entry-tooltip>
                                </div>
                                <div v-if="!isRequired" class="delete-entry" v-on:click="unsetReference()">
                                    <font-awesome-icon :icon="['fal', 'minus-circle']"/>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>

                <v-btn v-if="isCreateNewEntryAllowed" flat
                       v-on:click="emitNestedCreation">
                    <span class="capitalize-text">create new {{field.name}}</span>
                    <span class="icon-spacer"></span>
                    <font-awesome-icon :icon="['far', 'plus']"/>
                </v-btn>
                <v-btn flat v-on:click="openModal()">
                    <span class="capitalize-text">{{chooseEntryText}}</span>
                    <span class="icon-spacer"></span>
                    <font-awesome-icon :icon="['far', 'link']"/>
                </v-btn>
            </div>

            <div v-if="validationText !== ''" class="hint-text custom-validation-error-text">
                {{validationText}}
            </div>
            <div v-else class="hint-text">{{description}}</div>
            <transition name="fade">
                <div v-if="selectionModalState">
                    <div class="modal-container" v-on:click="closeModal">
                        <div class="horizontal">
                            <div class="modal-content" v-on:click.stop>
                                <div class="body">
                                    <div>
                                        <v-card>
                                            <v-toolbar dark color="accent">
                                                <v-toolbar-title>
                                                    <span class="capitalize-text">{{chooseEntryText}}</span>
                                                </v-toolbar-title>
                                            </v-toolbar>
                                            <v-divider></v-divider>
                                            <div class="search-bar">
                                                <div class="search-icon-container">
                                                    <span><font-awesome-icon :icon="['fal', 'search']"
                                                                             class="search-input"/></span>
                                                </div>
                                                <v-text-field
                                                        color="accent"
                                                        placeholder="Type to search for entries"
                                                        v-model="searchTerm"
                                                ></v-text-field>
                                            </div>
                                            <div v-if="isMedia" class="media-filters-bar">
                                                <v-container fluid py-0>
                                                    <v-layout row wrap>
                                                        <v-flex xs3 v-for="filter in mediaFilters"
                                                                :key="filter.category">
                                                            <v-checkbox
                                                                    hide-details
                                                                    :label="filter.category"
                                                                    v-model="filter.active"
                                                            ></v-checkbox>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </div>
                                            <div v-else-if="doesReferenceContentTypeHaveNestedReference">
                                                <reference-filter :mode="referenceFilterMode"></reference-filter>
                                            </div>
                                            <div class="references-list-container">
                                                <v-list>
                                                    <v-list-tile
                                                            v-for="entry in filteredChooseExistingEntries"
                                                            v-bind:data="entry"
                                                            v-bind:key="entry.id"
                                                            class="entry"
                                                            v-bind:class="{'selected-entry':isSelected(entry)}"
                                                            v-on:click="setReference(entry)">
                                                        <v-list-tile-title>
                                                            <span class="capitalize-text">{{getPrimaryDisplayName(entry)}}</span>
                                                        </v-list-tile-title>
                                                        <v-list-tile-action>
                                                            <transition name="fade">
                                                                <template v-if="isSelected(entry)">
                                                        <span><font-awesome-icon
                                                                :icon="['fal', 'check-circle']"/></span>
                                                                </template>
                                                            </transition>
                                                        </v-list-tile-action>
                                                    </v-list-tile>
                                                </v-list>
                                            </div>
                                            <div class="actions-container">
                                                <v-btn v-on:click="closeModal()">
                                                    <span class="capitalize-text">Done</span>
                                                </v-btn>
                                            </div>
                                        </v-card>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </transition>
        </template>
        <template v-else>
            <div>
                <v-progress-linear :indeterminate="true" color="accent"></v-progress-linear>
            </div>
        </template>
    </div>

</template>

<script>
    import BaseLoadingComponent from '../BaseLoading'

    import {
        EVENT_INPUT,
        EVENT_TOUCHED,
        EVENT_VALIDATION_STATE,
        EVENT_NESTED_CREATION,
        DEFAULT_LOCALE,
        GET_LOCALE_DISPLAY_NAME,
        LOAD_SPACE_CONTENT,
        LOADING_PRISTINE,
        SUPER_ADMIN_ROLE,
        VALIDATION_CATEGORY,
        SET_REFERENCE_FIELD_CONTENT_TYPE,
        SET_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_TERM,
        GET_FILTERED_ENTRIES_REFERENCE_FIELD_CHOOSE_EXISTING,
        MODE_REFERENCE_FILTER_CHOOSE_EXISTING, CLEAR_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES,
    } from '../../services/constants'
    import helpers from '../../services/helpers'

    export default {
        name: 'sfr-reference-field',
        extends: BaseLoadingComponent,
        props: {
            field: Object,
            valid: Boolean,
            inputValue: [Number, Array],
        },
        model: {
            prop: 'inputValue',
            event: EVENT_INPUT
        },
        data: function () {
            return {
                isRequired: this.field.required,
                value: this.inputValue,
                validationText: '',
                selectionModalState: false,
                mediaFilters: [],
            }
        },
        computed: {
            searchTerm: {
                get() {
                    return this.$store.state.referenceFieldState.chooseExistingFilterTerm
                },
                set(newValue) {
                    this.$store.commit(SET_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_TERM, newValue)
                }
            },
            filteredChooseExistingEntries() {
                const entries = this.$store.getters[GET_FILTERED_ENTRIES_REFERENCE_FIELD_CHOOSE_EXISTING]
                if (this.isMedia && this.mediaFilters.some(filter => {
                    return filter.active
                })) {
                    return entries.filter(entry => {
                        const mediaTypeField = this.getMediaTypeOfEntry(entry)
                        return !!this.mediaFilters.filter(mediaFilter => {
                            return mediaFilter.active
                        }).find(mediaFilter => {
                            return mediaFilter.category === mediaTypeField.category
                        })
                    })
                } else {
                    return entries
                }
            },
            header() {
                return this.computeFieldHeader(this.field)
            },
            isValid() {
                return this.valid
            },
            validationRules() {
                return [
                    this.isRequired ? (v) => {
                        return this.field.allowsMultiple ? v.length > 0 || `Please select ${this.field.name}` : true
                    } : () => true,
                ]
            },
            referenceFilterMode() {
                return MODE_REFERENCE_FILTER_CHOOSE_EXISTING
            },
            description() {
                const currentLocale = this.$store.state.locale.currentLocale
                return currentLocale === DEFAULT_LOCALE ? this.field.description : `${this.field.description} (${this.$store.getters[GET_LOCALE_DISPLAY_NAME](currentLocale)})`
            },
            isEditMode() {
                return helpers.isEditRoute(this.$route)
            },
            isMedia() {
                return this.field.referenceType === 'asset'
            },
            mediaTypes() {
                return this.$store.state.media.mediaTypes.filter((mediaType, index, self) => {
                    return self.findIndex(mediaType2 => {
                        return mediaType.category === mediaType2.category
                    }) === index
                })
            },
            storeReferenceContent() {
                return this.$store.state.spaceContent[this.field.referenceType]
            },
            allStoreReferenceContent() {
                return this.$store.state.spaceContent
            },
            referenceContentType() {
                return this.$store.state.spaceContentTypes.find(contentType => {
                    return contentType.identifier === this.field.referenceType
                })
            },
            doesReferenceContentTypeHaveNestedReference() {
                if (this.referenceContentType) {

                    return this.referenceContentType.fields.some(field => {
                        return field.referenceType && field.referenceType !== 'asset'

                    })
                }
                return false
            },
            currentUser() {
                return this.$store.state.currentUser
            },
            isCreateNewEntryAllowed() {
                return !(this.currentUser
                    && this.currentUser.role
                    && this.currentUser.role !== SUPER_ADMIN_ROLE
                    && this.referenceContentType
                    && this.referenceContentType.role
                    && this.referenceContentType.role === SUPER_ADMIN_ROLE)
            },
            chooseEntryText() {
                const sentence = []
                sentence.push('choose')
                if (this.isCreateNewEntryAllowed) {
                    sentence.push('existing')
                }
                sentence.push(this.field.name)
                return sentence.join(' ')
            },
        },
        methods: {
            computeFieldHeader(field) {
                return `${field.name}${field.required ? '* ' : ''}${field.allowsMultiple ? ' (Multiple)' : ''}:`
            },
            emitInput($event) {
                this.$emit(EVENT_INPUT, $event)
                this.$emit(EVENT_TOUCHED, true)
            },
            validate() {
                const validationResult = !this.validationRules.map(ruleFunc => {
                    const ruleResult = ruleFunc(this.value)
                    if (ruleResult !== true) {
                        this.validationText = ruleResult
                    } else {
                        this.validationText = ''
                    }
                    return ruleResult === true
                }).some(validationResult => {
                    return validationResult === false
                })
                if (validationResult !== this.isValid) {
                    this.emitValidationState(validationResult)
                }
            },
            isMediaField(field) {
                return field.referenceType === 'asset'
            },
            emitValidationState($event) {
                this.$emit(EVENT_VALIDATION_STATE, $event)
            },
            emitNestedCreation() {
                this.$emit(EVENT_NESTED_CREATION, this.field)
            },
            setReference(referencedEntry) {
                if (this.field.allowsMultiple) {
                    const i = this.value.indexOf(referencedEntry.id)
                    if (i > -1) {
                        this.value.splice(i, 1)
                    } else {
                        this.value.push(referencedEntry.id)
                    }
                } else {
                    if (this.value === referencedEntry.id) {
                        this.value = null
                    } else {
                        this.value = referencedEntry.id
                    }
                }
                this.emitInput(this.value)
                this.validate()
            },
            unsetReference(index) {
                if (this.field.allowsMultiple) {
                    this.value.splice(index, 1)
                } else {
                    this.value = null
                }
                this.emitInput(this.value)

            },
            displayReferenceEntry: helpers.getPrimaryDisplayName,
            getNameByIdentifier: helpers.getNameByIdentifier,
            getDisplayNameByIdentifier: helpers.getDisplayNameByIdentifier,
            valueToReferenceObj(value) {
                if (this.storeReferenceContent) {
                    return this.storeReferenceContent.find(entry => {
                        return entry.id === value
                    })
                } else {
                    return null
                }
            },
            getReferenceContent() {
                this.$store.dispatch(LOAD_SPACE_CONTENT, {
                    identifier: this.field.referenceType,
                });
            },
            getMediaTypeOfEntry(entry) {
                return helpers.getMediaTypeOfEntry(entry, this.$store.state)
            },
            getUrlField(fields) {
                return fields.find(field => {
                    return field.identifier === 'url'
                })
            },
            openModal() {
                this.$store.commit(SET_REFERENCE_FIELD_CONTENT_TYPE, this.field.referenceType)
                this.$store.commit(CLEAR_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES)
                this.selectionModalState = true;
            },
            closeModal() {
                this.selectionModalState = false;
            },
            isSelected(entry) {
                if (this.field.allowsMultiple) {
                    return this.value.indexOf(entry.id) > -1
                } else {
                    return this.value === entry.id
                }
            },
            initializeMediaFilters() {
                if (this.isMedia) {
                    const categoryValidation = this.field.validations.find(validation => {
                        return validation.name === VALIDATION_CATEGORY
                    })
                    let initialCategory = null
                    if (categoryValidation) {
                        initialCategory = categoryValidation.value
                    }
                    this.mediaTypes.forEach(mediaType => {
                        this.mediaFilters.push({
                            category: mediaType.category,
                            active: initialCategory && mediaType.category === initialCategory
                        })
                    })
                }
            },
            getPrimaryDisplayName: helpers.getPrimaryDisplayName,
        },
        created() {

            if (this.isEditMode || !this.isRequired) {
                this.validate()
            }
            this.initializeMediaFilters()
            if (!this.storeReferenceContent) {
                this.getReferenceContent()
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .regular-type-header {
        font-size: 14px;
        .input-group {
            padding: 0;
        }
    }

    .icon-spacer {
        width: 0.5em;
    }

    .linked-entry-container {
        display: flex;
        margin: 13px 0 0 0;
        padding: 0 0 0 4px;
    }

    .data-table-thumbnail {
        $size: 30px;
        max-height: $size;
        max-width: $size;
        vertical-align: middle;
        margin: 0 1em 0 0;
    }

    .category-icon {
        margin: 0 .5em 0 0;
    }

    .linked-entry {
        cursor: help;
        span {
            font-weight: bold;
            $border-width: 1px;
            border-bottom: $border-width solid $accent;
        }
    }

    .delete-entry {
        cursor: pointer;
        color: $error;
        margin: 0 0 0 .5em;
    }

    .hint-text {
        @extend %manual-description;

        &.custom-validation-error-text {
            color: $error
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .modal-container {
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(255, 255, 255); /* Fallback color */
        background-color: rgba(255, 255, 255, 0.8); /* Black w/ opacity */
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .horizontal {
        display: flex;
        justify-content: center;
    }

    .modal-content {
        background-color: #fefefe;
        /*margin: 15% auto; !* 15% from the top and centered *!*/
        width: 500px; /* Could be more or less, depending on screen size */
        box-shadow: 0 0 20px 13px #dcddde;
    }

    .search-bar {
        display: flex;
        align-items: center;
        padding: 0 1em;
    }

    .search-icon-container {
        margin: 0 1em 0 0;
    }

    .media-filters-bar {
        /*display: flex;*/
        /*justify-content: space-between;*/
    }

    .entry {
        border-left: $accent solid 0;
        transition: border-left-width .1s;
    }

    .selected-entry {
        border-left: $accent solid 4px;
        transition: border-left-width .1s;
    }

    .spinner {
        font-size: 20px;
    }

    .references-list-container {
        height: 40vh;
        overflow-y: scroll;
    }

    .actions-container {
        display: flex;
        justify-content: center;
        padding: 5px;
    }


</style>
